<template>
  <div class="flex layout-column elevation-0 pa-1"
       style="border-radius: 6px;overflow-y: hidden"
       :style="{'background': compColor.lxExpansion.background}">

    <div class="flex layout-column">
      <lx-data-table-simple
        tableName="ReportDetailsList"
        v-model="tableObj.selection"
        :items="reportItems"
        :headers="tableObj.headers"
        :loading="tableObj.loading"
        :no-data-text="$t('AG_GRID.NO_ROWS')"
        :hideContextFilter="true"
        :preventRowClick="true"
        :setHeightOnItems="true">

        <template v-slot:cellrenderer="{ value }">
          <!-- payment renderer -->
          <div v-if="value.f.renderer === 'payment'" class="layout-row">
            <span >{{ value.i[value.f.value] | currency }}</span>

            <v-tooltip bottom open-delay="1000" max-width="800">
              <template v-slot:activator="{ on }">
                <div v-on="on" class="layout-row ml-3 pb-1"
                     style="cursor: pointer;">
                  <v-icon :color="compColor.prime" small>info</v-icon>
                </div>
              </template>

              <div class="pt-2 px-2">
                <p style="text-align: justify;">{{ $t('REPORT_LIST_DETAILS.MESSAGE_TOOLTIP_PAYMENT') }}</p>
              </div>
            </v-tooltip>
          </div>
        </template>
      </lx-data-table-simple>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReportDetailsList',
  props: ['reportId'],
  data () {
    return {
      reportItems: [],
      tableObj: {
        loading: false,
        headers: [
          {
            text: this.$t('REPORT_LIST_DETAILS.TABLE.DIAGNOSES'),
            value: 'diagnosis'
          },
          {
            text: this.$t('REPORT_LIST_DETAILS.TABLE.PROGRESS'),
            value: 'progress'
          },
          {
            text: this.$t('REPORT_LIST_DETAILS.TABLE.THERAPIES'),
            value: 'therapies'
          },
          {
            text: this.$t('REPORT_LIST_DETAILS.TABLE.OTHERS'),
            value: 'others',
            width: '360px'
          },
          {
            text: this.$t('REPORT_LIST_DETAILS.TABLE.EXPECTED_PAYMENT'),
            value: 'payment',
            renderer: 'payment'
          }
        ]
      }
    }
  },
  created () {
    this.getReportDetails()
  },
  methods: {
    /**
     * Get details for current report row from db
     */
    getReportDetails () {
      if (this.tableObj.loading) return
      this.tableObj.loading = true

      this.$http.get('/reports/details/' + this.reportId)
        .then(res => {
          if (res.data) {
            this.$set(this, 'reportItems', [res.data])
          }
        })
        .catch(this.NotifyError)
        .finally(() => {
          this.tableObj.loading = false
        })
    }
  }
}
</script>
